// Establishes the global jQuery that the legacy jQuery plugin stack attaches to.
//
// jQuery's UMD build (`dist/jquery.js`) exports the jQuery function but does NOT
// set `window.jQuery`/`window.$` when consumed as a module. The legacy plugins
// (jQuery UI, select2, tooltipster, periodpicker, …) either look for a global
// `jQuery` or `require('jquery')` — both must resolve to the SAME instance the
// 1000+ app modules import via `import $ from 'jquery'`. Assigning the module
// singleton to the globals here guarantees a single shared jQuery.
//
// This module MUST be imported before any plugin in `jquery-stack.ts`.
import $ from 'jquery';

declare global {
	interface Window {
		$: typeof $;
		jQuery: typeof $;
	}
}

window.$ = window.jQuery = $;

export default $;
